import { useBlock } from "@/components/PowerBlock/Block/block-store";
import { MCPConfiguration } from "@/types/evaluate";

const useMCPConfiguration = () => {
  const blockStore = useBlock<MCPConfiguration>();

  // // Initialize configuration if not present
  // useEffect(() => {
  //   if (!blockStore.configuration) {
  //     blockStore.setConfiguration({
  //       server_configuration: {
  //         server_url: "",
  //         headers: {},
  //       },
  //       function_name: "",
  //       input_data: [],
  //     });
  //   }
  // }, [blockStore]);

  // Derive values from configuration
  const serverUrl = blockStore.configuration?.server_configuration?.server_url || "";
  const headers = blockStore.configuration?.server_configuration?.headers || {};
  const functionName = blockStore.configuration?.function_name || null;
  const inputData = blockStore.configuration?.input_data || [];

  return {
    blockStore,
    serverUrl,
    headers,
    functionName,
    inputData,
  };
};

export default useMCPConfiguration;
